const moduleRoute = {
  path: '/seo',
  name: 'Seo',
  redirect: {
    name: 'Positions'
  },
  component: () => import('../Module.vue'),
  children: [
    {
      path: 'positions',
      name: 'Positions',
      component: () => import(/* webpackChunkName: "positions" */ '../views/Positions.vue'),
      meta: {
        title: 'Текущие позиции'
      }
    },
    {
      path: 'indicators',
      name: 'Indicators',
      component: () => import(/* webpackChunkName: "indicators" */ '../views/Indicators.vue'),
      meta: {
        title: 'Показатели сайта'
      }
    },
    {
      path: 'works',
      name: 'Works',
      component: () => import(/* webpackChunkName: "promotion_works" */ '../views/Works.vue'),
      meta: {
        title: 'Работы по продвижению'
      }
    },
    {
      path: 'report',
      name: 'MonthlyReport',
      component: () => import(/* webpackChunkName: "monthly_report" */ '../views/MonthlyReport.vue'),
      meta: {
        title: 'Отчеты по SEO'
      }
    },
    {
      path: 'documents',
      name: 'Documents',
      component: () => import(/* webpackChunkName: "accounting_documents" */ '../views/Documents.vue'),
      meta: {
        title: 'Бухгалтерские документы'
      }
    }
  ]
}

export default router => {
  router.addRoutes([moduleRoute])
}
